// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2IXhF","label":"Completed_label__UU216"};